export default __webpack_public_path__ + "static/business_4-bbbc0eab82f5beaa9926c0fecb016a1c.jpg";